import React, { useState } from 'react';
import { formatPriceWithSymbol } from '../../utils/currency';
import { useFormik } from "formik";
import * as Yup from "yup";
import { IoClose } from 'react-icons/io5';
import { MdFastfood } from "react-icons/md";
import SafeImage from "../../components/SafeImage";
import { FiTrash2 } from 'react-icons/fi';
import { BsPlusCircle } from 'react-icons/bs';
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import { getStoredUser } from '../../utils/safeStorage';

import { registerGrupoAdicionais, deleteGrupoAdicional, deleteItemAdicional } from "../../services/api";
import '../../styles/modal-shared.css';

import ModalAddItemAdicional from "./ModalAddItemAdicionais";

const ModalAddGroupAdicionais = ({
    showModalAddGroupAdd,
    setShowModalAddGroupAdd,
    selectDataAdicionais,
    setselectDataAdicionais,
    refresh,
    setRefresh,
    item,
    setTempAdicionais,
    context // "item" para tela de edição de item, "list" para tela de lista de adicionais
}) => {
    const { t } = useTranslation('categorias');

    const userParse = getStoredUser();
    const userID = userParse?._id;
    const empresa = localStorage.getItem('empresa');
    const empresaParse = JSON.parse(empresa);
    const idEmpresa = empresaParse.id_empresa;

    const [mandatory, setMandatory] = useState(false);
    const [minimo, setMinimo] = useState(0);
    const [maximo, setMaximo] = useState(1);
    const [grupoAdicionaisCadastrado, setGrupoAdicionaisCadastrado] = useState(null);
    const [showModalAddItemAdd, setShowModalAddItemAdd] = useState(true);
    const [precificacao, setPrecificacao] = useState("soma");
    const [tipoGrupo, setTipoGrupo] = useState("simples");

    // Visibilidade: modal aparece quando showModalAddGroupAdd é true
    const isVisible = showModalAddGroupAdd;

    const closeModal = () => setShowModalAddGroupAdd(false);

    const handleCadastroItemAdicional = () => {
        setShowModalAddItemAdd(!showModalAddItemAdd);
    };

    // ──── Quantity handlers ────
    const handleMinimoChange = (event) => {
        const value = Math.min(Math.max(0, event.target.valueAsNumber), maximo);
        handleMinimoChangeWithMandatory(value);
    };

    const handleMaximoChange = (event) => {
        const value = Math.max(minimo, event.target.valueAsNumber);
        setMaximo(value);
    };

    const incrementMinimo = () => handleMinimoChangeWithMandatory(minimo < maximo ? minimo + 1 : minimo);
    const decrementMinimo = () => handleMinimoChangeWithMandatory(minimo > 0 ? minimo - 1 : minimo);
    const incrementMaximo = () => setMaximo(prev => prev + 1);
    const decrementMaximo = () => setMaximo(prev => (prev > minimo ? prev - 1 : prev));

    const handleMandatoryChange = (newMandatory) => {
        if (newMandatory) {
            setMandatory(true);
            if (minimo === 0) setMinimo(1);
        } else {
            setMandatory(false);
            setMinimo(0);
        }
    };

    const handleMinimoChangeWithMandatory = (newMinimo) => {
        setMinimo(newMinimo);
        setMandatory(newMinimo > 0);
    };

    // ──── Save / Refresh ────
    const handleSaveRefreshItem = () => {
        if (grupoAdicionaisCadastrado) {
            if (context === "item") {
                const value = grupoAdicionaisCadastrado._id;
                const label = grupoAdicionaisCadastrado.title;
                const newItem = { value, label };
                const exists = selectDataAdicionais.some(item => item.value === value);
                if (!exists) {
                    setTempAdicionais(prev => [...prev, newItem]);
                }
            }
            setRefresh(prev => !prev);
            setShowModalAddGroupAdd(false);
        }
    };

    // ──── Delete group ────
    const handleDeleteGroup = (categoriaToDelete) => {
        const idRecebido = categoriaToDelete._id;
        deleteGrupoAdicional(userID, idRecebido).then(cast => {
            if (cast.status === 201) {
                setGrupoAdicionaisCadastrado(null);
                setShowModalAddItemAdd(true);
                toast(cast.data.msg, { autoClose: 5000, type: "success" });
                setShowModalAddGroupAdd(false);
            } else {
                toast(cast.data.msg, { autoClose: 5000, type: "error" });
            }
        }).catch(err => {
            toast(err.response?.data?.msg || t('actions.error'), { autoClose: 5000, type: "error" });
        });
    };

    // ──── Delete item ────
    const handleDeleteItem = (id_grupo, id) => {
        const data = { userID, id_subadicional: id, id_grupo };
        deleteItemAdicional(data).then(response => {
            if (response.status === 200) {
                toast(response.data.msg, { autoClose: 5000, type: "success" });
                setGrupoAdicionaisCadastrado(response.data.grupoAdicional);
            } else {
                toast(response.data.msg, { autoClose: 5000, type: "error" });
            }
        }).catch(err => {
            toast(err.response?.data?.msg || t('actions.error'), { autoClose: 5000, type: "error" });
        });
    };

    // ──── Formik ────
    const SignUpSchema = Yup.object().shape({
        title: Yup.string().required(t('actions.required')),
    });

    const formik = useFormik({
        validationSchema: SignUpSchema,
        validateOnBlur: false,
        validateOnChange: false,
        initialValues: { title: "" },
        onSubmit: (values) => handleSubmitAPI(values.title),
    });

    const handleSubmitAPI = (title) => {
        const createdBy = userID;
        const out = false;
        const calcularMaiorValor = precificacao === "maior";
        const calcular_media = precificacao === "media";
        const type = tipoGrupo;

        registerGrupoAdicionais(createdBy, idEmpresa, title, minimo, maximo, mandatory, out, calcularMaiorValor, calcular_media, precificacao, type).then(cast => {
            if (cast.status === 201) {
                toast(cast.data.msg, { autoClose: 5000, type: "success" });
                if (context === "list") {
                    setRefresh(prev => !prev);
                    setShowModalAddGroupAdd(false);
                } else {
                    setGrupoAdicionaisCadastrado(cast.data.adicional);
                }
            } else {
                toast(cast.data.msg, { autoClose: 5000, type: "error" });
            }
        }).catch(err => {
            toast(err.response?.data?.msg || t('actions.error'), { autoClose: 5000, type: "error" });
        });
    };

    // ──── Render helpers ────
    const isFlavor = tipoGrupo === "pizza";

    const renderModalTitle = () => {
        if (grupoAdicionaisCadastrado) return t('addGroupModal.manageTitle');
        return isFlavor ? t('addGroupModal.titleFlavor') : t('addGroupModal.title');
    };

    const renderModalSubtitle = () => {
        if (grupoAdicionaisCadastrado) return t('addGroupModal.manageSubtitle');
        return isFlavor ? t('addGroupModal.subtitleFlavor') : t('addGroupModal.subtitle');
    };

    // ══════════════════════════════════════════════
    // RENDER
    // ══════════════════════════════════════════════
    return (
        <div className={isVisible ? 'pdj-modal-overlay' : 'pdj-modal-overlay--hidden'}>
            <div className="pdj-modal-box pdj-modal-box--wide">

                {/* ══════ ESTÁGIO 1: Formulário de criação ══════ */}
                {!grupoAdicionaisCadastrado ? (
                    <form onSubmit={formik.handleSubmit}>

                        {/* Header */}
                        <div className="pdj-modal-header">
                            <div className="pdj-modal-header-text">
                                <h2 className="pdj-modal-title">{renderModalTitle()}</h2>
                                <p className="pdj-modal-subtitle">{renderModalSubtitle()}</p>
                            </div>
                            <button type="button" className="pdj-modal-close-btn" onClick={closeModal}>
                                <IoClose />
                            </button>
                        </div>

                        {/* Body */}
                        <div className="pdj-modal-body">

                            {/* Tipo + Nome */}
                            <div className="pdj-modal-grid-1-2">
                                <div className="pdj-modal-field">
                                    <label className="pdj-modal-label">
                                        {t('addGroupModal.groupType')}
                                        <span className="pdj-modal-required">*</span>
                                    </label>
                                    <select
                                        className="pdj-modal-select"
                                        value={tipoGrupo}
                                        onChange={(e) => setTipoGrupo(e.target.value)}
                                    >
                                        <option value="simples">{t('addGroupModal.typeAdditional')}</option>
                                        <option value="pizza">{t('addGroupModal.typeFlavor')}</option>
                                    </select>
                                </div>

                                <div className="pdj-modal-field">
                                    <label className="pdj-modal-label">
                                        {t('addGroupModal.groupName')}
                                        <span className="pdj-modal-required">*</span>
                                    </label>
                                    <input
                                        className="pdj-modal-input"
                                        placeholder={isFlavor ? t('addGroupModal.groupNamePlaceholderFlavor') : t('addGroupModal.groupNamePlaceholder')}
                                        id="title"
                                        type="text"
                                        name="title"
                                        onChange={formik.handleChange}
                                        value={formik.values.title}
                                    />
                                    {formik.errors.title && (
                                        <span className="pdj-modal-error">{formik.errors.title}</span>
                                    )}
                                </div>
                            </div>

                            <hr className="pdj-modal-divider" />

                            {/* Quantidade + Obrigatoriedade + Precificação */}
                            <div className="pdj-modal-grid-3">

                                {/* Controles de Quantidade */}
                                <div className="pdj-modal-field">
                                    <label className="pdj-modal-label">{t('addGroupModal.quantity')}</label>
                                    <div style={{ display: 'flex', gap: '12px' }}>
                                        {/* Minimo */}
                                        <div style={{ flex: 1 }}>
                                            <label className="pdj-modal-label" style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px' }}>
                                                {t('editGroupModal.minimum')}
                                            </label>
                                            <div className="pdj-modal-stepper">
                                                <button type="button" onClick={decrementMinimo}>-</button>
                                                <input type="number" value={minimo} onChange={handleMinimoChange} />
                                                <button type="button" onClick={incrementMinimo}>+</button>
                                            </div>
                                        </div>
                                        {/* Maximo */}
                                        <div style={{ flex: 1 }}>
                                            <label className="pdj-modal-label" style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px' }}>
                                                {t('editGroupModal.maximum')}
                                            </label>
                                            <div className="pdj-modal-stepper">
                                                <button type="button" onClick={decrementMaximo}>-</button>
                                                <input type="number" value={maximo} onChange={handleMaximoChange} />
                                                <button type="button" onClick={incrementMaximo}>+</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Obrigatório / Opcional */}
                                <div className="pdj-modal-field">
                                    <label className="pdj-modal-label">{t('addGroupModal.selectionType')}</label>
                                    <div className="pdj-modal-radio-group">
                                        {/* Opcional */}
                                        <div
                                            className={`pdj-modal-radio-card${!mandatory ? ' pdj-modal-radio-card--active' : ''}`}
                                            onClick={() => handleMandatoryChange(false)}
                                        >
                                            <input
                                                type="radio"
                                                name="mandatory"
                                                checked={!mandatory}
                                                onChange={() => handleMandatoryChange(false)}
                                            />
                                            <div>
                                                <div className="pdj-modal-radio-card-label">{t('editGroupModal.optional')}</div>
                                                <div className="pdj-modal-radio-card-desc">{t('editGroupModal.optionalDesc')}</div>
                                            </div>
                                        </div>

                                        {/* Obrigatório */}
                                        <div
                                            className={`pdj-modal-radio-card${mandatory ? ' pdj-modal-radio-card--active' : ''}`}
                                            onClick={() => handleMandatoryChange(true)}
                                        >
                                            <input
                                                type="radio"
                                                name="mandatory"
                                                checked={mandatory}
                                                onChange={() => handleMandatoryChange(true)}
                                            />
                                            <div>
                                                <div className="pdj-modal-radio-card-label">{t('editGroupModal.required')}</div>
                                                <div className="pdj-modal-radio-card-desc">{t('editGroupModal.requiredDesc')}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Precificação */}
                                <div className="pdj-modal-field">
                                    <label className="pdj-modal-label">
                                        {t('editGroupModal.pricing')}
                                        <span className="pdj-modal-required">*</span>
                                    </label>
                                    <select
                                        className="pdj-modal-select"
                                        value={precificacao}
                                        onChange={(e) => setPrecificacao(e.target.value)}
                                    >
                                        <option value="soma">{t('editGroupModal.pricingSum')}</option>
                                        <option value="media">{t('editGroupModal.pricingAverage')}</option>
                                        <option value="maior">{t('editGroupModal.pricingHighest')}</option>
                                    </select>
                                    <div className="pdj-modal-info-box">
                                        {precificacao === "soma" && t('editGroupModal.pricingSumDesc')}
                                        {precificacao === "media" && t('editGroupModal.pricingAverageDesc')}
                                        {precificacao === "maior" && t('editGroupModal.pricingHighestDesc')}
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* Footer */}
                        <div className="pdj-modal-footer">
                            <button type="button" className="pdj-modal-btn pdj-modal-btn--secondary" onClick={closeModal}>
                                {t('actions.cancel')}
                            </button>
                            <button type="submit" className="pdj-modal-btn pdj-modal-btn--primary">
                                {context === "list" ? t('addGroupModal.saveAndClose') : t('addGroupModal.continue')}
                            </button>
                        </div>

                    </form>
                ) : (
                    /* ══════ ESTÁGIO 2: Gerenciar itens ══════ */
                    <>
                        {/* Header */}
                        <div className="pdj-modal-header">
                            <div className="pdj-modal-header-text">
                                <h2 className="pdj-modal-title">{t('addGroupModal.manageTitle')}</h2>
                                <p className="pdj-modal-subtitle">{t('addGroupModal.manageSubtitle')}</p>
                            </div>
                            <button type="button" className="pdj-modal-close-btn" onClick={closeModal}>
                                <IoClose />
                            </button>
                        </div>

                        {/* Body */}
                        <div className="pdj-modal-body">

                            {/* Card do grupo criado */}
                            <div style={{
                                border: '1.5px solid #e2e8f0',
                                borderRadius: '12px',
                                overflow: 'hidden',
                            }}>
                                {/* Group header */}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '14px 16px',
                                    background: '#fafbfc',
                                    borderBottom: '1px solid #f0f0f0',
                                    gap: '12px',
                                    flexWrap: 'wrap',
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, minWidth: 0, flexWrap: 'wrap' }}>
                                        <span style={{ fontSize: '15px', fontWeight: 600, color: '#1e293b' }}>
                                            {grupoAdicionaisCadastrado.title}
                                        </span>
                                        <span className={`pdj-modal-badge ${grupoAdicionaisCadastrado.mandatory ? 'pdj-modal-badge--red' : 'pdj-modal-badge--blue'}`}>
                                            {grupoAdicionaisCadastrado.mandatory ? t('editGroupModal.required') : t('editGroupModal.optional')}
                                        </span>
                                        <span style={{ fontSize: '12px', color: '#64748b' }}>
                                            {t('selectableRange', { min: grupoAdicionaisCadastrado.min, max: grupoAdicionaisCadastrado.max })}
                                        </span>
                                    </div>
                                    <button
                                        type="button"
                                        className="pdj-modal-btn pdj-modal-btn--danger"
                                        onClick={() => handleDeleteGroup(grupoAdicionaisCadastrado)}
                                        style={{ flexShrink: 0 }}
                                    >
                                        <FiTrash2 /> {t('actions.delete')}
                                    </button>
                                </div>

                                {/* Items list */}
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    {grupoAdicionaisCadastrado.adicionais && grupoAdicionaisCadastrado.adicionais.length > 0 ? (
                                        grupoAdicionaisCadastrado.adicionais.map((adicional) => (
                                            <div
                                                key={adicional._id}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    padding: '12px 16px',
                                                    borderBottom: '1px solid #f0f0f0',
                                                    gap: '12px',
                                                }}
                                            >
                                                {/* Image + Name */}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, minWidth: 0 }}>
                                                    <SafeImage
                                                        src={adicional.image}
                                                        alt={adicional.title}
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            borderRadius: 8,
                                                            objectFit: 'cover',
                                                            border: '1px solid #e2e8f0',
                                                            flexShrink: 0,
                                                        }}
                                                        fallback={
                                                            <div style={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: 8,
                                                                background: '#f1f5f9',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                flexShrink: 0,
                                                                color: '#94a3b8',
                                                            }}>
                                                                <MdFastfood style={{ fontSize: 20 }} />
                                                            </div>
                                                        }
                                                    />
                                                    <span style={{ fontSize: '14px', fontWeight: 500, color: '#1e293b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {adicional.title}
                                                    </span>
                                                </div>

                                                {/* Price + Delete */}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
                                                    <span style={{ fontSize: '13px', color: adicional.price > 0 ? '#1e293b' : '#94a3b8', fontWeight: 500 }}>
                                                        {adicional.price > 0
                                                            ? t('addGroupModal.startingFrom', { price: formatPriceWithSymbol(adicional.price) })
                                                            : t('addGroupModal.freeAdditional')
                                                        }
                                                    </span>
                                                    <button
                                                        type="button"
                                                        className="pdj-modal-btn pdj-modal-btn--icon"
                                                        onClick={() => handleDeleteItem(grupoAdicionaisCadastrado._id, adicional._id)}
                                                        style={{ color: '#dc2626', background: '#fef2f2' }}
                                                        title={t('actions.delete')}
                                                    >
                                                        <IoClose />
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="pdj-modal-empty">
                                            <span className="pdj-modal-empty-text">{t('addGroupModal.noItems')}</span>
                                        </div>
                                    )}

                                    {/* Register item button */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '14px 16px',
                                            cursor: 'pointer',
                                            color: '#318CD5',
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            gap: '6px',
                                            transition: 'background 150ms ease',
                                            borderTop: '1px solid #f0f0f0',
                                        }}
                                        onClick={() => handleCadastroItemAdicional()}
                                        onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(49, 140, 213, 0.04)'}
                                        onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                    >
                                        <BsPlusCircle />
                                        {grupoAdicionaisCadastrado.type === "pizza" ? t('addGroupModal.registerFlavor') : t('addGroupModal.registerItem')}
                                    </div>
                                </div>
                            </div>

                            {/* Nested modal for adding items */}
                            <ModalAddItemAdicional
                                showModalAddItemAdd={showModalAddItemAdd}
                                setShowModalAddItemAdd={setShowModalAddItemAdd}
                                id_grupo={grupoAdicionaisCadastrado._id}
                                setGrupoAdicionaisCadastrado={setGrupoAdicionaisCadastrado}
                            />

                        </div>

                        {/* Footer */}
                        <div className="pdj-modal-footer">
                            <button type="button" className="pdj-modal-btn pdj-modal-btn--secondary" onClick={closeModal}>
                                {t('actions.back')}
                            </button>
                            <button
                                type="button"
                                className="pdj-modal-btn pdj-modal-btn--primary"
                                onClick={handleSaveRefreshItem}
                            >
                                {context === "list" ? t('addGroupModal.saveAndClose') : t('addGroupModal.addToItem')}
                            </button>
                        </div>
                    </>
                )}

            </div>
        </div>
    );
};

export default ModalAddGroupAdicionais;
